import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiMapPin } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import GolfClubAutocomplete from '../../components/GolfClubAutocomplete';
import HoleCountToggle from '../../components/HoleCountToggle';
import { useCreateRoundWizard } from '../../contexts/CreateRoundWizardContext';

function StepDetails() {
  const navigate = useNavigate();
  const { state, setDetails } = useCreateRoundWizard();

  const handleNext = () => {
    navigate(`/create-round/${state.mode}/who`);
  };

  const canContinue = !!state.course;

  return (
    <div>
      <p className="text-sm text-text-muted mb-6">
        Choose the course and how many holes you'll play.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <div>
          <label className="block text-sm font-semibold text-text-secondary mb-3">
            <SafeIcon icon={FiMapPin} className="w-4 h-4 inline mr-2" />
            Golf course
          </label>
          <GolfClubAutocomplete
            selectedCourse={state.course}
            onCourseSelect={(course) => setDetails(course, state.holeCount)}
            placeholder="Type first word to search..."
            className="w-full"
          />
        </div>
        <div>
          <HoleCountToggle
            holeCount={state.holeCount}
            onHoleCountChange={(n) => setDetails(state.course, n)}
          />
        </div>
      </div>

      <div className="mt-8 flex justify-end">
        <button
          onClick={handleNext}
          disabled={!canContinue}
          className="px-6 py-3 bg-accent text-white rounded-md hover:bg-interactive-hover transition-all duration-200 font-semibold disabled:opacity-50 min-h-[44px]"
        >
          Continue
        </button>
      </div>
    </div>
  );
}

export default StepDetails;
